import { Drawer } from "@design-system/Drawer";
import classNames from "classnames";
import { useDubPartnersPublicToken } from "@api/dubPartners.api";
import { Loader } from "@design-system/Loader/Loader";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { useOverlays } from "../../../contexts/OverlayContext";
import styles from "./ReferralDrawer.module.scss";

export const ReferralDrawer: React.FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("referralDrawer");
    const { data: publicTokenData, isLoading: isLoadingPublicToken } =
        useDubPartnersPublicToken();

    const renderContent = () => {
        if (isLoadingPublicToken) {
            return <Loader />;
        }

        if (!publicTokenData?.publicToken) {
            return (
                <EmptyState
                    header="Referrals unavailable"
                    body="Unable to load referral program. Please try again later."
                />
            );
        }

        return (
            <iframe
                src={`https://app.dub.co/embed/referrals?token=${publicTokenData.publicToken}`}
                allow="clipboard-write"
                className={classNames("w-100 border-0", styles.referralIframe)}
            />
        );
    };

    return (
        <Drawer
            open={!!overlayInfo && !overlayIsClosing}
            onClose={closeOverlay}
            headerAddonLeft="Refer &amp; earn"
            noPadding
        >
            {renderContent()}
        </Drawer>
    );
};
